import { render } from "./CreateImmediateTaggingView.vue?vue&type=template&id=3b7979f1&scoped=true"
import script from "./CreateImmediateTaggingView.vue?vue&type=script&lang=js"
export * from "./CreateImmediateTaggingView.vue?vue&type=script&lang=js"

import "./CreateImmediateTaggingView.vue?vue&type=style&index=0&id=3b7979f1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7979f1"]])

export default __exports__